import "swiper/swiper-bundle.css";
import Slider from "../components/slider/Slider";
import "../styles/slider.css";
import ModulesSlider from "../components/slider/ModulesSlider";
import Toast from "../components/notification/Toast";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";

const Home = () => {
  const [isToastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [question, setQuestion] = useState("");
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const hash = sessionStorage.getItem("scrollTo");
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
      sessionStorage.removeItem("scrollTo");
    }
  }, [location]);
  
  const isValidEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isValidEmail(userEmail)) {
      setToastMessage("Некоректний email");
      setToastVisible(true);
      return;
    }

    const postData = {
      userName,
      userEmail,
      question,
    };

    try {
      const response = await fetch("/api/posts", {
        method: "POST",
        headers: {
          "Content-Type": "application/ld+json",
        },
        body: JSON.stringify(postData),
      });

      if (response.ok) {
        setToastMessage("Форму відправлено успішно!");
        setToastVisible(true);
        setUserName("");
        setUserEmail("");
        setQuestion("");
      } else {
        setToastMessage("Помилка при надсиланні форми.");
        setToastVisible(true);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setToastMessage("Виникла помилка при надсиланні.");
      setToastVisible(true);
    }
  };


  const handleCopyPhone = () => {
    navigator.clipboard.writeText("+38 063 34 34 598");
    setToastMessage("Номер телефону скопійовано!");
    setToastVisible(true);
  };

  return (
    <>
      <img
        src="/img/grid.png"
        alt="grid cover"
        className="absolute -top-10 left-1/2 -translate-x-1/2 z-1"
      />
      <Toast
        message={toastMessage}
        isVisible={isToastVisible}
        onClose={() => setToastVisible(false)}
      />
      <section className="flex flex-col items-center max-container pt-6 px-3 md:pt-14 relative z-2" id="top">
        <img src="/img/diguni-logo1.svg" alt="diguni logo" className="w-[90%] max-w-[500px]" />
        <h1 className="text-[20px] font-bold text-black-gray text-center mt-4 md:text-[60px] max-w-[800px]">
          {t('welcome')} <a href="#contacts" className="text-light-blue">{t('inOneClick')}</a>
        </h1>
        <p className="text-[16px] text-center mt-2 md:text-[24px] text-black-gray">
          {t('welcomeMessage')}
        </p>
      </section>
      <section className="flex flex-col items-center max-container px-3 mt-8 md:mt-20">
        <img src={t("topBG")} alt="student cabinet profile page screen" className="relative z-[10]" />
      </section>
      <section
        id="about"
        className="flex flex-col gap-4 items-start lg:flex-row bg-white max-container pt-12 px-3 md:pt-14 lg:pt-24 z-[11] relative -top-20 shadow-[0px_-40px_50px_-20px_rgba(255,255,255,1)]"
      >
        <div className="flex flex-col lg:w-[50%]">
          <h2 className="text-[24px] font-bold mb-2 lg:text-[50px] text-black-gray">
            {t('aboutDUHeader')}
          </h2>
          <p className="text-[16px] md:text-[20px] text-black-gray">
            <span className="text-light-blue font-bold">{t('DU')}</span>{t('aboutDUText')}
          </p>
          <h3 className="text-gray-400 text-[20px] font-bold mt-4 w-full text-center mb-6 md:text-left md:mb-2 md:text-[28px]">
            {t('trusted')}
          </h3>
          <div className="flex flex-col items-center gap-12 md:flex-row">
            <img className="w-40 h-auto" src="/img/politech-logo.svg" alt="ztu logo" />
            <img className="w-24 h-auto" src="/img/KAI-logo.svg" alt="nau logo" />
            <img className="w-24 h-auto" src="/img/KNUBA-logo.png" alt="nau logo" />
          </div>
        </div>
        <img
          src={t('middleBg')} alt="portal admission campaign statistic"
          className="hidden md:block lg:w-[50%]"
        />
      </section>

      <section
        id="modules"
        className="w-full bg-background flex flex-col items-center justify-center py-12 md:py-24 relative pl-3"
      >
        <div className="max-container w-full">
          <h2 className="text-[24px] md:text-[70px] font-bold mb-4 md:mb-12 text-black-gray">
            {t('whatDUHas')}
          </h2>
        </div>
        <ModulesSlider slidesData={'modules1'}/>
        <ModulesSlider slidesData={'modules2'}/>
      </section>
      <section className="w-full pt-20 pl-2" id="implementation">
        <Slider />
      </section>
      <section id="contacts" className="bg-background w-full py-24 flex justify-center">
        <div className="max-container w-full flex flex-col px-3">
          <h2 className="text-[24px] md:text-[70px] font-bold mb-4 md:mb-12 text-black-gray">{t('contactUs')}</h2>
          <div className="flex flex-col md:flex-row gap-12">
            <div className="bg-white border border-gray-200 shadow-sm p-5 md:p-6 rounded-2xl w-full max-w-md mx-auto flex flex-col gap-3">
              <div className="flex flex-col text-black-gray">
                <span className="text-sm md:text-base font-medium">{t('phone')}</span>
                <span
                  onClick={handleCopyPhone}
                  className="cursor-pointer text-base md:text-lg underline font-semibold hover:text-gray-600 transition-colors"
                >
                  +38 063 34 34 598
                </span>
              </div>

              <div className="text-sm md:text-base text-black-gray">
                <span className="font-medium">{t('address')}:</span> {t('addressPlace')}
              </div>

              <div className="text-sm md:text-base text-black-gray">
                <span className="font-medium">Email:</span>{" "}
                <a
                  className="underline hover:text-gray-500 transition-colors"
                  href="mailto:info@digitaluniversity.com.ua"
                >
                  info@digitaluniversity.com.ua
                </a>
              </div>

              <div className="text-sm md:text-base font-medium text-black-gray">
                {t('companyName')}
              </div>
            </div>
            <div className="w-full md:w-[50%]">
              <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
                <div className="flex flex-col gap-4 items-center">
                  <input
                    type="text"
                    placeholder={t('name')}
                    className="p-4 rounded-xl w-full"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    required
                  />
                  <input
                    type="email"
                    placeholder="Email..."
                    className={`p-4 rounded-xl w-full border ${
                      userEmail && !isValidEmail(userEmail) ? 'border-red-500' : 'border-gray-300'
                    }`}
                    value={userEmail}
                    onChange={(e) => setUserEmail(e.target.value)}
                    required
                  />
                </div>
                <textarea
                  placeholder={t('question')}
                  className="w-full h-[200px] p-4 rounded-xl resize-none"
                  value={question}
                  onChange={(e) => setQuestion(e.target.value)}
                  required
                ></textarea>
                <button
                  type="submit"
                  className="p-2 bg-light-blue text-white text-[16px] rounded-xl uppercase transition-all duration-300 hover:bg-blue-600"
                >
                  {t('contactNow')}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <section className="max-container flex flex-col md:flex-row gap-4 items-center pt-12 md:pb-12 px-3 w-full">
        <div className="mb-4">
          <h2 className="text-[26px] lg:text-[40px] font-bold mb-4 text-black-gray">{t('footerTitle')}</h2>
          <p className="text-[16px] lg:text-[20px] mt-2 mb-4 text-black-gray">{t('footerData')}</p>
        </div>
        <img src="/img/bg-bottom-cut.png" alt="student cabinet settings form"
             className="hidden md:block w-[80%]"/>
      </section>
      <section className="max-container w-full flex flex-col md:flex-row items-center gap-4 justify-center py-4">
        <img src={t('innovationLogo')} alt="innovation hub logo" className="w-[80%] max-w-[200px]"/>
      </section>
    </>
  );
};

export default Home;
